function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M3.531 14.018l1.73-6.958c.064-.257-.265-.424-.435-.22L.104 12.506C-.526 7.311 1.587 1.896 9.6 0c1.202 6.557-.162 11.12-6.069 14.018z",
  fill: "#5B5E68",
  fillRule: "evenodd"
});

var SvgLeaf = function SvgLeaf(props) {
  return React.createElement("svg", _extends({
    width: 14,
    height: 14
  }, props), _ref);
};

export default SvgLeaf;